import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';

const KPIS = [
  'CHANNEL_MIX',
  'CHANNEL_DISC_PCT',
  'CHANNEL_DISC_AMT',
  'WEIGHTED_DISC_PCT',
  'WEIGHTED_DISC_AMT',
  'EXPOSED_UNITS',
  'EXPOSED_GROSS_SALES',
  'LIABILITY',
];

export const DemForecastChannelPerspective = ({ forecastId }) => {
  const views = [
    {
      name: 'By Product',
      dims: ['FORECAST', 'PROD', 'PERIOD', 'CHANNEL'],
      kpis: KPIS,
      dimToPeriodicities: {
        PERIOD: ['YEAR', 'QTR', 'MON'],
      },
      disabledDims: ['FORECAST'],
    },
    {
      name: 'By Channel',
      dims: ['FORECAST', 'CHANNEL', 'PROD', 'PERIOD'],
      kpis: KPIS,
      dimToPeriodicities: {
        PERIOD: ['YEAR', 'QTR', 'MON'],
      },
      disabledDims: ['FORECAST'],
    },
  ];

  const defaultDimFilters = { FORECAST: [forecastId] };

  return <EntityPerspective views={views} defaultDimFilters={defaultDimFilters} entity={'FORECAST_CHANNEL'} />;
};
